import {
	LaravelResponse,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withOptionsEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
	withUsagesEndpoint,
} from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import axios, { AxiosRequestConfig } from "axios";
import {
	ContactViewIndexResource,
	ContactViewOptionResource,
	ContactViewRequest,
	ContactViewUpdateResource,
} from "../types/contactView";

const baseKey = "contact-views";
const indexAllKey = [baseKey, "all"];
export const contactViewService = {
	...withIndexEndpoint<ContactViewIndexResource>([baseKey]),
	...withShowEndpoint<ContactViewUpdateResource>([baseKey]),
	...withDestroyEndpoint([baseKey]),
	...withStoreEndpoint<ContactViewRequest>([baseKey]),
	...withUpdateEndpoint<ContactViewRequest>([baseKey]),
	...withOptionsEndpoint<ContactViewOptionResource>([baseKey]),
	...withUsagesEndpoint([baseKey]),
	indexAll: (config?: AxiosRequestConfig) =>
		axios.get<LaravelResponse<ContactViewIndexResource[]>>(keyToUrl(indexAllKey), config),
	indexAllKey,
};

const initialContactViews: ContactViewIndexResource[] = [];
const contactViewsFetcher = () => contactViewService.indexAll().then((r) => r.data.data);
export const useContactViewsQuery = () => {
	const { data, isLoading } = useQuery({
		queryKey: contactViewService.indexAllKey,
		queryFn: contactViewsFetcher,
	});

	return {
		data: data || initialContactViews,
		isLoading,
	};
};
